import React from 'react';
import { ArrowRight } from 'lucide-react';
import { trackInitiateCheckout } from '../utils/fbPixel';
const HOTMART_URL = 'https://pay.hotmart.com/H105419209E';
interface CTAButtonProps {
  text: string;
  onClick?: () => void;
  className?: string;
  href?: string;
}
export const CTAButton: React.FC<CTAButtonProps> = ({
  text,
  onClick,
  className = '',
  href
}) => {
  const handleClick = (e: React.MouseEvent) => {
    if (href) {
      // Only track InitiateCheckout if they are actually going to Hotmart
      trackInitiateCheckout();
    }
    if (onClick) {
      onClick();
    }
  };
  const baseClasses = `bg-[#FF8C00] hover:bg-[#e67e00] text-white font-bold py-4 px-8 rounded-2xl shadow-[0_8px_20px_rgba(255,140,0,0.3)] transform transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_12px_25px_rgba(255,140,0,0.4)] w-full md:w-auto text-lg md:text-xl flex items-center justify-center gap-3 no-underline ${className}`;
  if (href) {
    return <a href={href} target="_blank" rel="noopener noreferrer" onClick={handleClick} className={baseClasses} data-id="element-19">
        {text}
        <ArrowRight className="w-6 h-6" data-id="element-20" />
      </a>;
  }
  return <button onClick={handleClick} className={baseClasses} data-id="element-21">
      {text}
      <ArrowRight className="w-6 h-6" data-id="element-22" />
    </button>;
};